import { apiGet, apiPost, unwrap } from './apiClient';
import type { ResponseDTO, AdeDeviceDTO, DeviceSyncResult } from '@/types/api';

const BASE = '/api/v1/ade/devices';

export async function syncAllDevices(adeAccountId: string) {
  const res = await apiPost<ResponseDTO<DeviceSyncResult>>(
    `${BASE}/sync/all`,
    undefined,
    { params: { adeAccountId }, includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function listAdeDevices(adeAccountId: string) {
  const res = await apiGet<ResponseDTO<AdeDeviceDTO[]>>(
    `${BASE}/`,
    { params: { adeAccountId }, includeTenantHeader: true }
  );
  return unwrap(res);
}

export async function listDevicesByProfile(profileId: string) {
  const res = await apiGet<ResponseDTO<AdeDeviceDTO[]>>(
    `${BASE}/profile/${profileId}`,
    { includeTenantHeader: true }
  );
  return unwrap(res);
}
